import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";

function PromoCodeList(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onDeletePromoCode,
  } = props;
  return (
    <div class="b-table">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th> Promo code </th>
              <th> Description </th>
              <th> Start date </th>
              <th> Expiry date </th>
              <th> Discount </th>
              <th> Limit of usage </th>
              <th> Users </th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {listData &&
              listData?.map((datum, i) => (
                <tr key={i}>
                  <td data-label="Name" className="capitalize">
                    {datum.name}
                  </td>
                  <td data-label="Email">{datum.description}</td>
                  <td data-label="Email">{datum.startDate}</td>
                  <td data-label="Email">{datum.endDate}</td>
                  <td data-label="Email">{datum.discount}%</td>
                  <td data-label="Email">{datum.usageLimit}</td>
                  <td data-label="Email">{datum.usesCount}</td>

                  <td class="is-actions-cell" align="end">
                    <div class="buttons is-right ">
                      <Link
                        to={"/org-promo-code/details/" + datum.id}
                        class="button is-small is-primary"
                        type="button"
                      >
                        <FontAwesomeIcon className="mdi" icon={faEye} />
                        &nbsp;View
                      </Link>
                      <div
                        onClick={() => onDeletePromoCode(datum.id)}
                        className="button is-small"
                      >
                        <FontAwesomeIcon className="mdi" icon={faTrash} />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <div class="columns">
          <div class="column is-half">
            <span class="select">
              <select
                class={`input has-text-grey-light`}
                name="pageSize"
                onChange={(e) => setPageSize(parseInt(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map(function (option, i) {
                  return (
                    <option
                      selected={pageSize === option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div class="column is-half has-text-right">
            {previousCursors.length > 0 && (
              <button class="button" onClick={onPreviousClicked}>
                Previous
              </button>
            )}
            {listData.hasNextPage && (
              <>
                <button class="button" onClick={onNextClicked}>
                  Next
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoCodeList;
